<template>
    <div style="font-size: 1.1rem">
        <b-navbar toggleable="lg" type="dark" variant="info">
            <b-navbar-brand to="/">Drive CRM</b-navbar-brand>
            <b-navbar-nav v-if="selectedDomainName">
                <b-nav-item-dropdown :text="selectedDomainName" right>
                    <b-dropdown-item :active="domain.id === selectedDomain.id" v-for="domain in domains"
                                     :key="domain.id" @click="selectDomain(domain)">
                        {{domain.domain_name}}
                    </b-dropdown-item>
                </b-nav-item-dropdown>
            </b-navbar-nav>

            <b-navbar-nav v-if="isDomainLoading">
                <b-nav-item>
                    <font-awesome-icon icon="spinner" spin></font-awesome-icon>
                </b-nav-item>
            </b-navbar-nav>


            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
                <b-navbar-nav v-if="selectedDomainName">
                    <b-nav-item to="/" v-if="isAuthenticated">Статистика</b-nav-item>
                    <b-nav-item to="/lead" v-if="isAuthenticated">Заявки</b-nav-item>
                </b-navbar-nav>
                <!-- Right aligned nav items -->
                <b-navbar-nav class="ml-auto">

                    <b-nav-item to="/register" v-if="!isAuthenticated">Зарегистрироваться</b-nav-item>
                    <b-nav-item to="/login" v-if="!isAuthenticated">Войти в систему</b-nav-item>
                    <b-nav-item-dropdown right v-if="isAuthenticated">
                        <!-- Using 'button-content' slot -->
                        <template slot="button-content">
                            <font-awesome-icon icon="user"></font-awesome-icon>&nbsp;
                            <span v-if="userName">{{userName}}</span>
                            <span v-else><font-awesome-icon icon="spinner" spin></font-awesome-icon>&nbsp;</span>

                        </template>

                        <b-dropdown-item to="/account">Профиль</b-dropdown-item>
                        <b-dropdown-item to="/domain">Мои сайты</b-dropdown-item>
                        <b-dropdown-divider></b-dropdown-divider>
                        <b-dropdown-item @click="logout()">Выход</b-dropdown-item>
                    </b-nav-item-dropdown>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>
    </div>
</template>
<script>
    import {AUTH_LOGOUT} from "../../store/actions/auth";
    import {DOMAINS_SELECT} from "../../store/actions/domains";

    export default {
        name: 'NavigationBar',
        computed: {
            isAuthenticated() {
                return this.$store.getters.isAuthenticated;
            },
            userName() {
                return this.$store.getters.userName;
            },
            domains() {
                return this.$store.state.domains.domains;
            },
            selectedDomain() {
                return this.$store.state.domains.selectedDomain;
            },
            selectedDomainName() {
                return this.selectedDomain ? this.selectedDomain.domain_name : '';
            },
            isDomainLoading() {
                return this.$store.state.domains.status === 'loading';
            }

        },
        methods: {
            logout: function () {
                this.$store.dispatch(AUTH_LOGOUT).then(() => this.$router.push('/login'))
            },
            selectDomain: function (domain) {
                this.$store.commit(DOMAINS_SELECT, domain)
            }
        },
    }
</script>